import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { RoleProductRate } from '../entities/role-product-rate';


export class RoleProductRatesRequest extends BaseRequest {
    roleProductRates : RoleProductRate[];
}
